import { useState, useEffect, forwardRef } from 'react';

export const SavedItems = forwardRef(({ isOpen, onClose }, ref) => {
  const [isVisible, setIsVisible] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    } else {
      // Delay hiding for animation
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const handleToggle = () => {
    onClose();
  };

  // if (!isOpen && !isVisible) return null;

  return (
    <div
      className="wrapper-saved"
      style={{
        display: isOpen ? 'block' : 'none',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'scale(1)' : 'scale(0)',
        transition: 'opacity 0.3s, transform 0.3s',
      }}
      ref={ref}
    >
      <div className="headers-items">
        <h3>YOUR SAVED DESIGNS</h3>
        <button
          type="button"
          className="saved-info-closed"
          aria-label="Close saved items"
          tabIndex={0}
          onClick={handleToggle}
        >
          ✕
        </button>
      </div>
      <div id="customizer-saved-items" />
    </div>
  );
});
